import styled, { CSSProperties } from "styled-components";
import bgMultiplier from "assets/bg-multiplier.png";
import Button from "components/Buttons/ThemeButton";
import { ELITE_DEALS_GOLD } from "pages/EliteDeals/helpers/colors";

interface ICardContainer {
	color: string;
	image?: string;
}

export const Container = styled.div<ICardContainer>`
	position: relative;
	font-size: 1em;
	background: ${(props) => props.color};
	border-radius: 1.625em;
	//margin: 0.625em 0 0.625em 0;
	animation: fadeIn 1s;
	width: 100%;
	max-width: 25em;
	height: auto;
	min-height: 18.25em;
	overflow: hidden;
	box-sizing: border-box;

	border-radius: 1.5em;
	border: 0.125em solid #fbbd05;
	background: linear-gradient(180deg, #fff 0%, #ffedb9 100%);
	box-shadow: 0 0 0.625em 0 #fbbd05 inset,
		0 0.375em 0.9375em 0 rgba(0, 0, 0, 0.15);

	@media (orientation: landscape) {
		min-width: 14.1875em;
		max-width: 19.25em;
		min-height: 24.9375em;

		&.three-cards {
			max-width: 100%;
		}
	}
`;

export const Header = styled.div<{ $backgroundImage: string }>`
	position: relative;
	background-image: url(${(props) => props.$backgroundImage});
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-size: cover;
	width: 100%;
	height: 5.3125em /*33%*/;
	padding: 0.4375em 1.4375em 0em;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 0.1em;
`;

export const DataContainer = styled.div`
	display: grid;
	grid-gap: 0.1875em;
	padding: 0.5em;
`;

export const Text = styled.span`
	&.title {
		font-size: 1.4375em;
		color: ${ELITE_DEALS_GOLD};
	}

	&.main-title {
		font-size: 1.875em;
	}

	&.subtitle {
		font-size: 0.75em;
	}

	&.number-value {
		font-size: 1.2em;
	}

	&.purchase-limit {
		font-size: 0.75em;
	}

	&.pois-bounty {
		font-size: 0.75em;
		color: #000000;
	}
`;

export const Title = styled.div`
	display: flex;
	font-family: Baloo;
	font-style: normal;
	font-weight: 400;
	color: #fff;
	-webkit-text-stroke-width: 0.4em;
	-webkit-text-stroke-color: #834800;
	paint-order: stroke fill;
	line-height: 1.5em;
	box-sizing: border-box;
	flex-wrap: nowrap;
	white-space: nowrap;
`;

export const SubTitle = styled.div`
	position: relative;
	display: flex;
	text-align: left;
	color: #834800;
	font-weight: 700;
	line-height: 0.9375em;
	margin-left: 0.5em;
`;

export const RewardsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	width: 100%;
	height: 5.625em;
	padding: 0.625em;
	box-sizing: border-box;
	margin: 0 auto;

	@media (orientation: landscape) {
		width: fit-content;
		height: 9.5625em;
		flex-wrap: wrap;
		justify-content: center;
	}
`;

export const RewardsBackground = styled.div`
	background: rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	width: 100%;
`;

export const Reward = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	@media (orientation: landscape) {
		flex-basis: 33%;
	}
`;

export const RewardWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	max-width: 3.2em;

	@media (orientation: landscape) {
		max-width: 2.9em;
	}
`;

export const RewardIcon = styled.img`
	object-fit: contain;
	width: 100%;
	height: 3.2em;

	@media (orientation: landscape) {
		height: 2.9em;
	}
`;

export const NumberValue = styled.span`
	min-width: 100%;
	font-family: "Baloo";
	color: #fff;
	z-index: 1;
	//text-shadow: 2px 1px 0px #000;
	-webkit-text-stroke-width: 0.24em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	display: flex;
	line-height: 0.75em;
	align-items: center;
	justify-content: flex-end;
	white-space: nowrap;
	transform: translateY(-10%);

	@media (orientation: landscape) {
		transform: translateY(-10%);
	}
`;

export const CrossOutValue = styled.div`
	position: relative;
	font-family: Inter;
	font-style: normal;
	font-weight: 700;
	color: #eb5757;
	display: flex;
	align-items: center;
	justify-content: center;
	width: max-content;
	z-index: 2;
	gap: 0.125em;

	&.reward {
		min-width: 100%;
		font-family: "Baloo";
		font-weight: 400;
		color: #eb5757;
		z-index: 1;
		//text-shadow: 2px 1px 0px #000;
		-webkit-text-stroke-width: 0.24em;
		-webkit-text-stroke-color: #000;
		paint-order: stroke fill;
		display: flex;
		line-height: 0.75em;
		align-items: center;
		justify-content: flex-end;
		white-space: nowrap;
		position: absolute;
		width: max-content;
		top: 50%;
		left: 50%;
		transform: translate(-50%, 20%);

		@media (orientation: landscape) {
			transform: translate(-50%, 0%);
		}
	}
`;

export const CrossOutLine = styled("span")`
	border-bottom: 2px solid #eb5757;
	width: 110%;
	height: 0.06em;
	display: block;
	position: absolute;
	top: 40%;
	left: -5%;
	transform: translateY(-40%);

	&.reward {
		border-radius: 2px;
		border: 1px solid #000;
		background: #eb5757;
	}
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	gap: 1em;
	justify-content: center;
	padding: 0.22em 0.5em;

	@media (orientation: landscape) {
		flex-direction: column;
		gap: 0.5em;
		padding: 0em 0.5em;
	}
`;

export const CustomButton = styled(Button)`
	width: 48%;
	padding-top: 0.5em;
	padding-bottom: 0.5em;
	font-size: 1em;
	height: 2.75em;
	border-radius: 0.75em;

	@media (orientation: landscape) {
		flex-direction: column;
		//width: 10.1875em;

		//new styles for landscape/desktop
		width: 80%;

		&.three-cards {
			width: 60%;
		}
	}
`;

export const LoyaltyPoints = styled.div`
	position: relative;
	background: rgba(0, 0, 0, 0.1);
	color: #333;
	font-weight: 700;
	padding: 0.5em 1.5em;
	border-radius: 15px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1px;
	box-sizing: border-box;
	height: 2.75em;

	&.crossout {
		padding: 0.2em 1.5em;
	}
`;

export const LoyaltyPointsRow = styled.div`
	font-size: 0.75em;
	display: flex;
	align-items: center;
	gap: 0.16em;
`;

export const Multiplier = styled.div`
	position: absolute;
	z-index: 1;
	font-size: 0.64em;
	top: -20%;
	right: -10%;
	width: 3em;
	height: 3em;
	background-image: url(${bgMultiplier});
	background-size: cover;
	background-position: center;
	display: flex;
	justify-content: center;
	align-items: center;

	> div {
		color: #fff;
		font-family: Baloo;
		font-size: 1.6em;
		font-style: normal;
		font-weight: 400;
		transform: rotate(15deg);
		span {
			font-size: 0.9em;
		}
	}

	&.has-decimals > div {
		font-size: 1.28em;
	}
	/* @media (orientation: landscape) {
		font-size: 1.2em;
	} */
`;

export const Message = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	height: 1.1em;
	padding: 0.3em 0em 0em;
	text-align: center;

	&.pois-bounty {
		padding: 0em 0em 0.3em;
	}
`;

export const CountdownStyles: CSSProperties = {
	position: "absolute",
	fontSize: "0.75em",
	marginLeft: "0em",
	top: "0.8em",
	right: "0.8em",
	left: "unset",
	padding: "0.2em 0.6em 0.2em 0.2em",
	gap: "0.3em",
	minWidth: "6.5em"
};

export const CountdownStylesLandscape: CSSProperties = {
	position: "absolute",
	fontSize: "0.75em",
	marginLeft: "0em",
	top: "0.6em",
	right: "0.6em",
	left: "unset",
	padding: "0.2em 0.6em 0.2em 0.2em",
	gap: "0.3em",
	minWidth: "6.5em"
};

export const CountdownIconStyles: CSSProperties = {
	minWidth: "1.9em",
	minHeight: "1.9em",
	margin: "0",
	padding: "0"
};

export const CountdownLabelStyles: CSSProperties = {
	position: "absolute",
	top: "0.24em",
	left: "2.78em",
	//transform: "translateX(-50%)",
	fontSize: "0.84em",
	lineHeight: "1em",
	whiteSpace: "nowrap",
	fontWeight: "550"
	//textShadow: "0 1.06px 0 rgba(0, 0, 0, 0.25)"
};

export const CountdownTimerStyles: CSSProperties = {
	marginLeft: "0em",
	marginTop: "0.95em",
	lineHeight: "1em",
	fontWeight: "550",
	display: "flex",
	justifyContent: "center",
	width: "100%",
	fontVariantNumeric: "tabular-nums"
	//textShadow: "0 1.06px 0 rgba(0, 0, 0, 0.25)"
};
